<template>
  <div style="justify-self: center;">
    <span
      class="status-modal"
      @click="openStatusGuideModal()"
    >
      <svg-loader
          class="header-title-info-icon"
          src="/static/images/icon-info.svg"
      />
      Status de rastreabilidade
    </span>

    <modal
      ref="traceabilityStatusGuide"
      :icon-enabled="false"
      :close-button-enabled="true"
      title="Entenda o que é cada Status da Rastreabilidade"
      template="question"
      first-button-text="Voltar"
      first-button-style="btn-quarternary"
      :hide-second-button="true"
      :hide-first-button="true"
      ref-name="traceabilityStatusGuide"
      @first-cta="closeStatusGuideModal()"
      @close="closeStatusGuideModal()"
    >
      <div class="status-glossary">
        <div
          v-for="(state, index) in statusUpdated"
          :key="index"
          class="status-glossary__row"
        >
          <div
            v-if="state.glossary"
            class="status"
          >
            <span
              class="bullet"
              :class="state.symbolColor"
            >
              •
            </span>
            <p>{{ state.translated }}</p>
          </div>
          <div class="glossary">
            {{ state.glossary }}
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import strings from '@/strings'

export default {
  name: 'TraceabilityModalStatus',
  data() {
    return {
      status: strings.traceabilityStatus,
    }
  },

  computed: {
    statusUpdated() {
      delete this.status['LAUDO_LIBERADO']
      return this.status
    },
  },
  methods: {
    openStatusGuideModal() {
      this.$refs.traceabilityStatusGuide.open()
    },
    closeStatusGuideModal() {
      this.$refs.traceabilityStatusGuide.close()
    },
  }
}
</script>

<style lang="scss">
  .status-modal {
    font-size: 12px;
    cursor: pointer;

    &:hover {
      color: #000;

      .header-title-info-icon {
        color: #7a7a7a;
      }
    }

    .md-icon {
      width: 20px;
      height: 20px;
    }
  }

  #traceabilityStatusGuide .md-dialog {
    width: 90%;
    max-width: 920px;

    .standard-modal__title {
      font-family: 'Exo 2', sans-serif !important;
      font-style: normal;
      font-weight: 300;
      font-size: 20px;
      line-height: 26px;
      color: #7f1a54;
      margin-bottom: 0.7em;
    }

    .standard-modal__container-cta {
      padding-top: 1em;
    }

    .status-glossary {
      background: #eaeaea;
      padding: 19px 23px 6px;
      border-radius: 6px;

      &__row {
        flex-direction: row;
        display: flex;
        margin-bottom: 5px;
        font-family: 'Exo 2', sans-serif !important;

        .status {
          display: flex;
          align-items: center;
          flex: 1;

          p {
            flex: 7;
            font-family: 'Exo 2', sans-serif !important;
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 26px;
            color: #4a4a4a;
          }

          span {
            flex: 0.8;
            font-size: 25px;
            font-weight: bold;
          }
        }

        .glossary {
          flex: 2;
          margin: auto;
          font-family: 'Exo 2', sans-serif !important;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 26px;
          color: #4a4a4a;
        }
      }
    }
  }
</style>